export default {
    DETAIL_OF_SAMSA_ORDER: (state, detail_of_samsa_order) => (state.detail_of_samsa_order = detail_of_samsa_order),
    ERROR_SAMSA_ORDER: (state, err) => (state.error_samsa_order = err),
    SUCCESS_API_SAMSA_ORDER: (state, api) => (state.success_api_samsa_order = api)
}